// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"0ee8b482","189":"b51c9272","244":"4b4e582f","378":"65c11ffa","438":"3cea7879","670":"ead072ca","721":"c021ad42","876":"45d34786"}[chunkId] + ".chunk.js";
};